import { useMutation, MutationHookOptions } from "@apollo/client"
import { gql } from "../gql"
import {
  UpdateBulkOffboardingMutation,
  UpdateBulkOffboardingMutationVariables,
} from "../gql/graphql"

const UPDATE_BULK_OFFBOARDING_MUTATION = gql(`
  mutation UpdateBulkOffboarding($bulkOffboardingId: ID!, $state: String!, $generateTosa: Boolean, $notifyCustomerAdmin: Boolean) {
    updateBulkOffboarding(
      input: { bulkOffboardingId: $bulkOffboardingId, state: $state, generateTosa: $generateTosa, notifyCustomerAdmin: $notifyCustomerAdmin }
    ) {
      errors
      terminations {
        id
        errors {
          attribute
          fullMessage
        }
      }
      additionalTerminationPayments {
        id
        errors {
          attribute
          fullMessage
        }
      }
    }
  }
`)

export const useUpdateBulkOffboarding = (
  options?: MutationHookOptions<
    UpdateBulkOffboardingMutation,
    UpdateBulkOffboardingMutationVariables
  >,
) => {
  return useMutation(UPDATE_BULK_OFFBOARDING_MUTATION, options)
}
